import { PageHandler } from 'components/ContentHandlers'
import { generateLandingPageProps } from 'utils/next'
import { setPageCacheControlHeaders } from 'utils/cache'

export async function getServerSideProps(context) {
  setPageCacheControlHeaders(context.res)
  const serverSideProps = await generateLandingPageProps(context)
  if (serverSideProps?.props?.content?.notFound) {
    return {
      notFound: true,
    }
  }
  return serverSideProps
}

export default function Landing({ content, isMobile }) {
  return <PageHandler pageContent={content} isMobileUA={isMobile} />
}
